module.exports = __webpack_public_path__ + "static/media/CircularStd-Black.6b37ec3a.ttf";